
const texts = {
    roles:{
        aFirmar:'Solicitar el rol para poder firmar documentos',
        aPublicar:'Solicitar el rol para poder publicar documentos',
        noRolASolicitar: 'No hay más roles disponibles para que los solicites',
        noRol: 'No tenés ningún rol asignado. Podés solicitar uno',
    },
    bienvenido:'¡Bienvenido,',
    rolDe:'Tu rol es',
    buttonOut: 'Salir',
  };
  
  export default texts;
  